import React, { Component } from 'react';
import Input from '../component/Input.js';
import SelectBox from '../component/Select.js';

export default class EditTiers extends Component {
	constructor(props){
		super(props);
		this.state = {points:'',status:'',original:{}};
		this.handleInput = this.handleInput.bind(this);
	}

	componentDidMount(){ //when component mounts, fill in current tier values in input fields
		this.setState({points:this.props.tiers.points,status:this.props.tiers.tier_status,original:this.props.tiers});
	}

	handleInput(identity,value){ //standard method for processing user input
		const theState = {};
		theState[identity] = value;
		this.setState(theState);
	}

	componentDidUpdate(prevProps){
		if(prevProps.save === false && this.props.save === true){ //if the user has chosen to save the edited values
			this.props.onSave({quantity:this.state.points,status:this.state.status,firstID:this.props.tiers.ID,misc:'edit'}); //pass up values to ManageTiers component
			let pID = this.props.id.toString()+"_points";
			if(this.state.points === ''){ //empty point values are not allowed, highlight empty point input fields
				document.getElementById(pID).style.borderColor="red";
			}else{ 
				document.getElementById(pID).style.borderColor="inherit";
			}
		}else if(prevProps.save === true && this.props.save === false && this.props.success){ //clear/reset input fields
		 	this.setState({points:'',status:'',original:{}});
		}
	}

	render(){
		const selectStyles = "h2 pa1 w-90 br2 bw1 ml2-ns truncate shadow-2";
		const inputStyles = "h2 br2 bw1 w-100 ml2-ns shadow-3 pl2 pr2";
		let priceType = this.props.app === "lov"?"Points: ":"Max Price: $";
		let pointsID = this.props.id.toString()+"_points";
		return(
			<div className="fl w-100 mt3">
				<div className="fl w-10">
					<p className="mt2 b navy">Tier: {this.props.tiers.tier}</p>
				</div>
				<div className="fl w-50">
					<div className="fl w-50 tr mt2 b navy">
						<label>{priceType} </label>
					</div>
					<div className="fl w-50 tl">
						<Input identity="points" id={pointsID} onInput={this.handleInput} type="number" val={this.state.points} inputStyle={inputStyles}/>
					</div>
				</div>
				<div className="fl w-40">
					<div className="fl w-50 tr mt2 b navy">
						<label>Status: </label>
					</div>
					<div className="fl w-50 tl">
						<SelectBox identity="status" onSelect={this.handleInput} val={this.state.status} options={["active","inactive"]} styles={selectStyles}/>
					</div>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/container/EditTiers.js